import { useAlert } from "../../context/AlertContext";
import { AlertComp } from "./alertComp";

export function AlertRenderer() {
  const { alertData, closeAlert } = useAlert();

  return (
    <AlertComp
      tipo={alertData.tipo}
      titulo={alertData.titulo}
      msg={alertData.msg}
      customIcon={alertData.customIcon}
      open={alertData.open}
      onClose={closeAlert}
    />
  );
}